import React from 'react';
import { Report } from 'cccisd-laravel-report';
import PlanReport from '../Report';

const Component = props => {
    return (
        <div style={{ width: '840px', margin: '0 auto', maxWidth: '100%' }}>
            <Report downloadFilename="PlanReport" height="600px">
                <PlanReport {...props} />
            </Report>
        </div>
    );
};

export default Component;
